import React, { Component, Suspense } from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";
import { Card, CardBody, Button } from "reactstrap";
import { Dropdown, Menu, Segment, Sidebar } from "semantic-ui-react";
import { connect } from "react-redux";
import FormFiltros from "./model/form";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Table from "./../Components/Table";
import Loader from "./../../Global/Loader";
import { DatePicker, Button as ButtonAnt, Skeleton } from "antd";
import { IconNewComment } from "./components/img";
import { Services } from "../../../repositories/clients/Services";
import moment from "moment";
import { Link } from "react-router-dom";
import axios from "axios";
import { openNotification } from "../Components/Notification";
import "./styles.scss";

import { moduleActions } from "../../Global/Permission/constants";
import { ShowForRole } from "../../Global/Permission/index";

import IMG_ADD from "../../../resources/icono_agregar.png";

let dateFormat = "YYYY-MM-DD";
const styles = {
  background: "red",
};
const Comments = React.lazy(() => import("../Components/Comments"));

const KeysFilter = [
  "POId",
  "PONumber",
  "StatusDesc",
  "SupplierName",
  "ConsigneeName",
  "DeliveryName",
  "DistributorPO",
  "ProjectName",
  "ContainerNumber",
  "CustomerContainerID",
];
const { RangePicker } = DatePicker;
const dateNow = new Date();

const fechaDescarga = `Fecha de descarga   ${dateNow.getDate().toString().padStart(2, "0") +
  "-" +
  (dateNow.getMonth() + 1).toString().padStart(2, "0") +
  "-" +
  dateNow.getFullYear()
  }`;
class PlanTransport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMovil: false,
      loadercomments: false,
      viewModalComments: false,
      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : "[0]",
      commentsData: [],
      users: [],
      rolId: this.props._rolId,
      userId: this.props._user,
      scrollLine: false,
      orders: [],
      data: [],
      loading: true,
      columns: [
        {
          label: "",
          id: "commentView",
          key: "commentViewAction",
          minWidth: 43,
          maxWidth: 43,
          noclick: true,
          custom: (value, triggerFn) => (
            <div
              title={this.props.t("comments")}
              onClick={() => {
                this.setState(
                  {
                    loadercomments: true,
                    viewModalComments: true,
                  },
                  () => this.getCommnets(value)
                );
              }}
            >
              {value.NewComments ? (
                <IconNewComment></IconNewComment>
              ) : (
                <span className="icon-comments icons-front-module" />
              )}
            </div>
          ),
        },
        {
          label: this.props.t("number"),
          key: "TransportPlanNo",
          minWidth: 195,
          maxWidth: 200,
          custom: (value) => (
            <Link
              className="underline-link"
              to={"/tp-detail-view/" + value.TransportPlanId}
            >
              {value.TransportPlanNo}
            </Link>
          ),
        },
        // { label: 'Plan de transporte No.', key: 'TransportPlanNo', minWidth: 180 },
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 175,
          maxWidth: 200,
          custom: (value) => (
            // <Button style={{width: value.Status === 'Pendiente Confirmación'?'auto': ''}} className={'btn-oval'} color={'Butoom'} onClick={() => { }}>{value.Status}</Button>
            <span class="badge badge-euro">{value.Status}</span>
          ),
        },
        {
          label: this.props.t("company"),
          key: "CustomerName",
          minWidth: 140,
          maxWidth: 200,
        },
        {
          label: this.props.t("order_ref_tp"),
          key: "RefOrderNumber",
          minWidth: 175,
          maxWidth: 200,
        },
        {
          label: this.props.t("reference_type"),
          key: "ReferenceType",
          minWidth: 175,
          maxWidth: 200,
        },
        {
          label: this.props.t("transport_mode"),
          key: "TransportMode",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          label: this.props.t("service_type"),
          key: "ServiceType",
          minWidth: 140,
          maxWidth: 200,
        },
        {
          label: this.props.t("shipment_type"),
          key: "ShipmentType",
          minWidth: 140,
          maxWidth: 200,
        },
        {
          label: this.props.t("planning"),
          key: "PlanningDate",
          minWidth: 140,
          maxWidth: 200,
        },
      ],
      searchOnInit: false,
      searchText: "",
      POId: 0,
      openComments: false,
      handleResCom: "unset",
      isSearchComments: true,
      tableLoader: false,
      advancedSearch: [],
      catalogCombo: [],
      advancedObj: [],
      AddSO: (
        <div className="float-right">
          <Button
            color="primary"
            className="d-flex align-items-center"
            title={this.props.t("create_new")}
            onClick={() => {
              this.addServiceOrder();
            }}
          >
            <span className="icon-plus icon-button-add" />
            {this.props.t("create_new")}
          </Button>
        </div>
      ),
      nameXlsx: `${this.props.t("tp_list")} - ${dateNow.getFullYear() +
        "" +
        (dateNow.getMonth() + 1).toString().padStart(2, "0") +
        "" +
        dateNow.getDate().toString().padStart(2, "0")
        }.xlsx`,
    };
  }

  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    this.setState({
      isMovil: isMobileDevice,
    });

    let newFormFiltros = [...FormFiltros];

    for (let i = 0; i < newFormFiltros.length; i++) {
      newFormFiltros[i].values = [];
    }

    this.setState(
      {
        advancedSearch: newFormFiltros,
      },
      () => {
        this.getOrdersList();
        this.getCatalogs();
      }
    );
  };

  getCommnets = (item, NewComments) => {
    let { CustomerId, TransportPlanId } = item;

    let moduleId = 1;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    axios
      .get(
        `${Services.PLANTRANSPORT.path}comment-plantrasp/get-comment?rowid=${TransportPlanId}&moduleid=${moduleId}&general=false&zona=${timezone}&lang=${this.props.lng}`
      )
      .then((response) => {
        let comentario = response.data.Comment;
        this.getUserMenciones(comentario, CustomerId, TransportPlanId, item);

        if (NewComments) {
          openNotification('success', NewComments);
        }
        // this.getUserMenciones(
        //   { commentsData: comentario,viewModalComments: true,
        //   }
        // );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUserMenciones = (comentario, CustomerId, ShipmentId, item) => {
    let { userId } = this.state;
    axios
      .get(
        `${Services.PLANTRANSPORT.path}comment-plantrasp/getUserMension?CustomerId=${CustomerId}&user=${userId}`
      )
      .then((response) => {
        this.setState({
          commentsData: comentario,
          users: response.data.data,
          rowid: ShipmentId,
          itemCommenSelect: item,
          loadercomments: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  newMessage = async (data) => {
    let { userId, rowid, itemCommenSelect } = this.state;
    data.Rowid = rowid;
    data.UserId = userId;
    data.ModuleId = 1;

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.PLANTRANSPORT.path}comment-plantrasp/add-comment`, data)
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_saved")
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteMessage = async (idDelete, toggle) => {
    let { itemCommenSelect } = this.state;

    axios
      .delete(
        `${Services.PLANTRANSPORT.path}comment-plantrasp/delete-comment/${idDelete}`
      )
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_deleted")
        );
        toggle()
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addServiceOrder = () => {
    this.props.history.push("/add-trasport-plan");
  };

  /*=============================================
  =            Get Order List                   =
  =============================================*/

  getOrdersList = async () => {
    let { advancedObj } = this.state;

    let ClientesIn =
      this.props.clients.length > 0
        ? JSON.stringify(this.props.clients)
        : "[0]";

    let data = {
      client: ClientesIn,
      advanced: advancedObj,
      userId: this.state.userId,
      lang: this.props.lng,
    };
    try {
      let success = await axios.post(
        `${Services.PLANTRANSPORT.path}plantrasp/listtp-all`,
        data
      );
      this.setState({ data: success.data.data, loading: false });
    } catch (err) {
      console.warn(err);
      this.setState({ loading: false });
    }
  };

  /*=============================================
 =            Get Order catalogs filter       =
 =============================================*/

  getCatalogs = () => {
    let { catalogCombo } = this.state;
    let id = this.props._user;
    let data = {
      client: this.state.clientesSelect,
    };

    axios
      .post(
        `${Services.PLANTRANSPORT.path}plantrasp/catalogs-filters/${id}?lang=${this.props.lng}`,
        data
      )
      .then((success) => {
        catalogCombo = success.data.data;
        this.setState(
          {
            catalogCombo,
            loading: false,
          },
          () => {
            this.generateFilters();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  handleChangeSelectMultiple = (id, value) => {
    let { advancedSearch, catalogCombo } = this.state;
    for (let i = 0; i < advancedSearch.length; i++) {
      const e = advancedSearch[i];
      if (e.id == id) {
        e.values = value;
      }
    }
    if (id == "TrasportMode") {
      advancedSearch[4].values = [];
    }
    this.setState({ advancedSearch }, () => {
      let catalogNuevo = catalogCombo["CatShipmentTypes"].filter((e) =>
        this.state.advancedSearch[2].values.includes(e.TransportModeId)
      );
      this.generateFilters(catalogNuevo);

      this.findAdvanced();
    });
  };

  handleChangeDate = (name) => (event) => {
    let { advancedSearch, catalogCombo } = this.state;
    let catalogNuevo = catalogCombo["CatShipmentTypes"].filter((e) =>
      this.state.advancedSearch[2].values.includes(e.TransportModeId)
    );

    try {
      if (event) {
        advancedSearch.map((search) => {
          if (search.id == name) {
            search.values = event.format("YYYY-MM-DD");
          }
        });
        this.setState({ advancedSearch }, () => {
          this.generateFilters(catalogNuevo);
          this.findAdvanced();
        });
      } else {
        advancedSearch.map((search) => {
          if (search.id == name) {
            search.values = "";
          }
        });
        this.setState({ advancedSearch }, () => {
          this.generateFilters(catalogNuevo);
          this.findAdvanced();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  handleChangeDatePicKer = (name) => (event) => {
    let { advancedSearch, catalogCombo } = this.state;
    let catalogNuevo = catalogCombo["CatShipmentTypes"].filter((e) =>
      this.state.advancedSearch[2].values.includes(e.TransportModeId)
    );
    try {
      if (event) {
        advancedSearch.map((search) => {
          if (search.id == name) {
            search.values = [
              {
                init: event[0].format("YYYY-MM-DD HH:mm:ss"),
                end: event[1].format("YYYY-MM-DD HH:mm:ss"),
              },
            ];
          }
        });
        this.setState({ advancedSearch }, () => {
          this.generateFilters(catalogNuevo);
          this.findAdvanced();
        });
      } else {
        advancedSearch.map((search) => {
          if (search.id == name) {
            search.values = [];
          }
        });
        this.setState({ advancedSearch }, () => {
          this.generateFilters(catalogNuevo);
          this.findAdvanced();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  resetAdvance = () => {
    let { advancedSearch } = this.state;
    advancedSearch.map((advData) => {
      if (advData.type === "Datetime") {
        advData.values = "";
      } else {
        advData.values = [];
      }
    });
    this.setState({ advancedSearch }, () => {
      this.generateFilters();
      this.findAdvanced();
    });
  };

  generateFilters = (newCat) => {
    const { advancedSearch, catalogCombo, Form } = this.state;
    let Inputs = advancedSearch.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            {/* <DatePicker
              className="col-md-12"
              placeholder={e.label}
              id={e.id}
              style={{
                height: "2.3em",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
              }}
              format={e.format}
              value={e.values === "" ? "" : moment(e.values, dateFormat)}
              defaultValue={e.values === "" ? "" : moment(e.values, dateFormat)}
              onChange={this.handleChangeDate(e.id)}
            /> */}
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                      moment(new Date(e.values[0].init)),
                      moment(new Date(e.values[0].end)),
                    ]
                    : []
                  : []
              }
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            // value={Array.isArray(filter.value) ? [moment(new Date(filter.value[0])), moment(new Date(filter.value[1]))] : []}
            // value={e.values === "" ? "" : moment(e.values, dateFormat)}
            // defaultValue={e.values === "" ? "" : moment(e.values, dateFormat)}
            // style={{ maxWidth: "60%" }}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              noResultsMessage={this.props.t("no_results_found")}
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              id={e.id}
              options={
                e.id === "ShipmentsType" && !newCat
                  ? []
                  : e.id === "ShipmentsType" && newCat
                    ? newCat
                    : catalogCombo[e.options]
              }
              clearable
              search
              selection
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
    });
    let NewInput = (
      <div className="col-12 row">
        <div className="col-12 d-flex justify-content-end">
          <span
            class="icon-clear icons-front-module"
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>
        {Inputs}
      </div>
    );

    this.setState({
      filtros: NewInput,
    });
  };

  findAdvanced = () => {
    let obj = [];
    this.state.advancedSearch.map((e) => {
      if (e.values.length > 0) {
        let newPush = {
          id: e.id2,
          UseIN: true,
          isDate: e.type === "Datetime" ? true : false,
          value: e.values,
        };
        obj.push(newPush);
      }
    });
    this.setState({ advancedObj: obj }, () => {
      this.getOrdersList();
    });
  };

  /*=============================================
  =            Selected Order                   =
  =============================================*/
  selectedOrder = (order) => {
    this.setState({
      POId: order.POId,
      PONumber: order.PONumber,
      openComments: true,
      handleResCom: "set",
      isSearchComments: true,
    });
  };

  handleClose = () => {
    this.setState({ openComments: false, isSearchComments: false });
  };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      data,
      columns,
      loading,
      searchOnInit,
      searchText,
      handleResCom,
      advancedSearch,
      filtros,
      viewModalComments,
      loadercomments,
      commentsData,
      itemCommenSelect,
      users,
      rolId,
      userId,
      scrollLine,
      isMovil,
    } = this.state;

    return (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-transport-plans icon-header" />
          {this.props.t("transports_plans")}
        </div>
        <Card className="myCard">
          <CardBody>
            {loading ? (
              <Loader />
            ) : (
              <Row>
                <Col md={12} xl={12}>
                  <Suspense fallback={<div>Loading...</div>}>
                    <Sidebar.Pushable as={Segment}>
                      <Sidebar
                        as={Menu}
                        animation="overlay"
                        icon="labeled"
                        style={{
                          maxHeight: "84%!important",
                          width: isMovil
                            ? window.innerWidth - window.innerWidth * 0.19
                            : 400,
                        }}
                        direction="right"
                        // onHide={() => setVisible(false)}
                        vertical
                        id="sidebarComentsTp"
                        visible={viewModalComments}
                        className="custom-sidebar"
                      >
                        <div className=" col-12 close_container">
                          <div className="header_comments">
                            {itemCommenSelect
                              ? itemCommenSelect.TransportPlanNo
                              : ""}
                          </div>
                          <div
                            className="close_icon2"
                            onClick={() => {
                              this.setState({ viewModalComments: false });
                            }}
                          >
                            <ButtonAnt
                              size="small"
                              type="primary"
                              shape="circle"
                            >
                              X
                            </ButtonAnt>
                          </div>
                        </div>
                        <div style={{ height: "3em" }} className=" col-12">
                          {" "}
                        </div>

                        {loadercomments === true ? (
                          <Skeleton active paragraph={{ rows: 17 }} />
                        ) : (
                          <div className=" col-12">
                            <Comments
                              commentTableList={true}
                              rolId={rolId}
                              userId={userId}
                              data={commentsData}
                              catalogs={users}
                              scrollLine={scrollLine}
                              funtionNewMessage={this.newMessage}
                              funtionDeleteMessage={this.deleteMessage}
                            />
                          </div>
                        )}
                      </Sidebar>

                      <Sidebar.Pusher>
                        <Segment basic>
                          <Table
                            columns={columns}
                            toFilter={KeysFilter}
                            data={data ? data : []}
                            advancedSearchData={advancedSearch}
                            advanceSearchFunction={() => {
                              this.setAdvanced();
                            }}
                            nameXlsx={this.state.nameXlsx}
                            itemsByPage={10}
                            styles={styles}
                            filtrosPanel={filtros}
                            name="planTransporte"
                            modalName="ui Modal body order list"
                            customer={this.props._customer}
                            user={this.props._user}
                            customAdd={
                              <ShowForRole
                                rol={this.props._rolId}
                                moduleAction={
                                  moduleActions.PLAN_TRANSPORTE_ALTA
                                }
                              >
                                {this.state.AddSO}
                              </ShowForRole>
                            }
                            // info={{
                            //   config: {
                            //     title: fechaDescarga,
                            //     titlePosition: {
                            //       col: 6,
                            //       row: 5,
                            //     },
                            //   },
                            // }}
                            options={{
                              xlsxPosition: "left",
                              pagination: true,
                              search: true,
                              searchKeys: [
                                "TransportPlanNo",
                                "Status",
                                "CustomerName",
                                "RefOrderNumber",
                                "TransportMode",
                                "ServiceType",
                                "ShipmentType",
                                "PlanningDate",
                                "ReferenceType"
                              ],
                              validateData: true,
                              panel: true,
                              modal: false,
                              downloads: {
                                xlsx: true,
                                pdf: false,
                              },
                              selectItems: false,
                              orderAttention: {
                                activeFilter: searchOnInit,
                                activeText: searchText,
                                search: true,
                                xlsx: true,
                              },
                              sheetName: this.props.t("tp"),
                              trigger: this.selectedOrder,
                              handleResCom: handleResCom,
                            }}
                            cellType={"thick-rows"}
                          />
                        </Segment>
                      </Sidebar.Pusher>
                    </Sidebar.Pushable>
                  </Suspense>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(PlanTransport)));
